import React, { Component, useRef } from "react";
import Switch from "react-switch";
import axios from "axios";
// import * as io from "socket.io-client";
import io from "socket.io-client";
import "../../styles/App.css";
import { InputLabel, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

///////////////////////////////////////////////////////////////////////////////////

// const classes = useStyles();
// var mqtt = require("mqtt");
// // var host = "ws://192.168.0.199:3000";
// var host = "ws://192.168.0.199:3000";
// var options = {
//   keepalive: 3600,
//   protocolId: "MQTT",
//   protocolVersion: 4,
//   clean: true,
//   reconnectPeriod: 1000,
//   connectTimeout: 30 * 1000,
//   will: {
//     topic: "WillMsg",
//     payload: "Connection Closed abnormally..!",
//     qos: 0,
//     retain: false,
//   },
//   username: "",
//   password: "",
//   rejectUnauthorized: false,
// };
// var mqttClient = mqtt.connect(host, options);

// const MQTT = require("async-mqtt");
// // const client = MQTT.connect("tcp://192.168.0.199:3000");
// const client = MQTT.connect("tcp://192.168.0.199:3000");

class SelectionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DefaultChecked: props.message,
      checked: "not yet",
      flag: false,
      topic: props.topic,
      currentMode: "0",
      changeModeTo: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    this.setState({ changeModeTo: event.target.value });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.message !== this.props.message && this.state.flag == false) {
      this.setState({ currentMode: this.props.message });
    }
    // if (prevState.changeModeTo !== this.state.changeModeTo) {
    //   this.setState({flag : true})
    //   mqttClient.publish(
    //     "hamk/iot/valkeakoski/kontti/ui/" + this.state.topic + "/" + this.state.changeModeTo,
    //     this.state.changeModeTo
    //   );
    // }
  }

  componentWillMount() {}
  componentWillUpdate() {}

  render() {
    return (
      <label>
        <div>
          <Select
            style={{
              color: "red",
            }}
            labelId="label"
            id="select"
            value={this.state.flag == false ? this.state.currentMode : this.state.changeModeTo}
            onChange={this.handleChange}
          >
            <MenuItem value="0">OFF</MenuItem>
            <MenuItem value="1">MANUAL</MenuItem>
            <MenuItem value="2">AUTO</MenuItem>
            <MenuItem value="3">START</MenuItem>
          </Select>
        </div>
      </label>
    );
  }
}

export default SelectionList;
